import React, { Component } from 'react';
import {
  Grid,
  Row,
  Col,
  Navbar,
  FormGroup,
  FormControl,
  InputGroup,
} from 'react-bootstrap';
import Card from 'components/Card/Card.jsx';
import Button from 'components/CustomButton/CustomButton.jsx';
import Modal from 'react-responsive-modal';
import immutable from 'object-path-immutable';

//Redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as SalesActions from './redux/SalesActions';
import auth from '../../libCustom/auth';

import numeral from 'numeral';
import moment from 'moment';

//ag-grid
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import localeText from './../../components/localeTextAgGrid';

import FolioCellRenderer from './../../components/CellRenderer/FolioCellRenderer';
import TypeFolioCellRenderer from './../../components/CellRenderer/TypeFolioCellRenderer';
import PagoOperadorCellRenderer from './../../components/CellRenderer/PagoOperadorCellRenderer';
import CouponCellRenderer from './../../components/CellRenderer/CouponCellRenderer';
import ActionsButtonCellRenderer from './../../components/CellRenderer/SalesActionsButtonCellRenderer';
import SaleLImitDate from '../../components/CellRenderer/saleLimitDate';
import WidgetSearchName from './widget-searchName';
import feathers from './../../feathers';

const formatCash = (params) => {
  return numeral(params.value).format('$0,00.00');
};

const formatDate = (params) => {
  return params.value ? moment(params.value).utc().format('DD-MM-YYYY') : '';
};

const operatorList = (params) => {
  const array = params.data.operatorsList || [];
  if (array.length > 0) {
    let string = '';
    array.map((item) => {
      string += `${item.name}, `;
    });
    return string.slice(0, string.length - 2);
  }
};

const defaultColDef = {
  filterable: true,
  filter: true,
  sortable: true,
  resizable: true,
  suppressMenu: false,
  enableFilter: true,
};
const columnDefs = [
  {
    headerName: 'FECHA DE CREACIÓN',
    field: 'createdAt',
    valueFormatter: formatDate,
    width: 100,
  },
  {
    headerName: 'FECHA LÍMITE DE PAGO',
    cellRenderer: 'SaleLImitDate',
    with: 130,
  },
  {
    headerName: 'FECHA DE CIERRE',
    field: 'dateSaleNote',
    valueFormatter: formatDate,
    width: 130,
  },
  {
    headerName: 'FOLIO',
    field: 'folio',
    cellRenderer: 'folioCellRenderer',
    width: 170,
  },

  {
    headerName: 'TIPO',
    field: 'folio',
    valueGetter: (params) => {
      return `${params.data.prefolio !== undefined || 'Nota de venta'} ${params.data.folio !== undefined || 'Orden de venta'
        }`;
    },
    filterable: true,
    cellRenderer: 'typeFolioCellRenderer',
    width: 120,
  },
  {
    headerName: 'CLIENTE',
    field: 'client',
    valueGetter: (params) => {
      const clientId = params.data.clientId || null;
      const client = params.data.client || null;

      if (clientId && clientId.firstName)
        return `${clientId.firstName} ${clientId.lastName || ''}`;
      if (client && client.firstName)
        return `${client.firstName} ${client.lastName || ''}`;
    },
    filterable: true,
    width: 123,
  },
  {
    headerName: 'DESTINO',
    field: 'salesInformation.destination',
    filterable: true,
    width: 98,
  },
  {
    headerName: 'OPERADOR',
    field: 'operatorsList',
    valueGetter: operatorList,
    width: 125,
  },
  {
    headerName: 'MONTO',
    field: 'balance.totalPrice',
    filterable: true,
    valueFormatter: formatCash,
    width: 108,
  },
  {
    headerName: 'ACCIONES',
    field: 'actions',
    cellRenderer: 'actionsButtonCellRenderer',
    minWidth: 98,
    maxWidth: 98,
  },
  {
    headerName: 'PAGO OPERADOR',
    field: 'balance.totalDebit',
    cellRenderer: 'pagoOperadorCellRenderer',
    width: 85,
  },
  {
    headerName: 'CÓDIGO DE CUPÓN',
    field: 'operatorsPaymentSale',
    cellRenderer: 'couponCellRenderer',
    width: 125,
  },
  {
    headerName: 'TOTAL OPERADOR',
    field: 'balance.totalBuyPrice',
    valueFormatter: formatCash,
    width: 108,
  },
  {
    headerName: 'OTROS GASTOS',
    field: 'balance.otherExpenses',
    valueFormatter: formatCash,
    width: 108,
  },
  {
    headerName: 'COMISIÓN AGENTE',
    field: 'balance.commissions',
    valueFormatter: formatCash,
    width: 108,
  },
  {
    headerName: 'ASIGNADO A',
    field: 'salesInformation.assignedTo',
    valueGetter: (params) => {
      const assignedTo = params.data.salesInformation.assignedTo || null;
      const user = params.data.user || null;
      if (assignedTo && assignedTo.firstName)
        return `${assignedTo.firstName} ${assignedTo.lastName || ''}`;
      if (user && user.firstName)
        return `${user.firstName} ${user.lastName || ''}`;
    },
    width: 120,
  },
];

const frameworkComponents = {
  folioCellRenderer: FolioCellRenderer,
  typeFolioCellRenderer: TypeFolioCellRenderer,
  pagoOperadorCellRenderer: PagoOperadorCellRenderer,
  couponCellRenderer: CouponCellRenderer,
  actionsButtonCellRenderer: ActionsButtonCellRenderer,
  SaleLImitDate: SaleLImitDate,
};

class SearchBox extends Component {
  constructor(props) {
    super(props);
    this.state = { value: props.value || '' };
    this.timeout = null;
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== undefined && nextProps.value !== this.state.value && nextProps.value === '') {
      this.setState({ value: '' });
    }
  }
  handleChange = (e) => {
    const val = e.target.value;
    this.setState({ value: val });
    if (this.timeout) clearTimeout(this.timeout);
    if (!val || val.trim() === '') {
      this.props.onSearch('');
      return;
    }
    this.timeout = setTimeout(() => {
      this.props.onSearch(val);
    }, 400);
  };
  render() {
    return (
      <FormControl
        type="text"
        placeholder="Buscar por cliente, folio, destino..."
        value={this.state.value}
        onChange={this.handleChange}
      />
    );
  }
}



class SalesIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      modalType: '',
      searchData: null,    // <-- Si es null, la tabla muestra los datos originales
      isSearching: false,   // <-- Indicador de carga
      searchIndex: [],
      dates: {
        startDate: moment().startOf('month').format('YYYY-MM-DD'),
        endDate: moment().endOf('month').format('YYYY-MM-DD'),
      },
      reportSales: {
        startDate: null,
        endDate: null,
        viewReport: false,
      },
      selectedDate: true,
      franchiseId: auth.getCurrentUser().franchiseId,
      clientId: '',
      assignedTo: '',
      page: 1,
      pageSize: 50,
      totalRecords: 0,
      loadingSales: false,
    };
  }

  async componentWillMount() {
    if (!auth.verifyLogin()) return false;

    await this.loadSales(1);
    this.loadSearchIndex();
  }

  loadSearchIndex = async () => {
    try {
      const franchiseId = this.state.franchiseId;
      const result = await feathers.service('sales').find({
        query: {
          franchiseId,
          $sort: { createdAt: -1 },
          $limit: 1000,
          $select: [
            'folio', 'prefolio', 'createdAt', 'dateSaleNote',
            'salesInformation', 'operatorsList', 'balance',
            'operatorsPaymentSale', 'delete', 'clientId', 'assignedTo',
          ],
          $populate: [
            { path: 'clientId', select: ['firstName', 'lastName'], match: { _id: { $ne: null } } },
            { path: 'salesInformation.assignedTo', select: ['firstName', 'lastName'], match: { _id: { $ne: null } } },
            { path: 'assignedTo', select: ['firstName', 'lastName'] },
          ],
        },
      });
      const list = result && result.data ? result.data : (Array.isArray(result) ? result : []);
      this.setState({ searchIndex: list });
    } catch (err) {
      console.warn('Error cargando índice de búsqueda:', err);
    }
  };

  loadSales = async (page = 1) => {
    const franchiseId = auth.getCurrentUser().franchiseId;

    this.setState({ loadingSales: true });

    try {
      const query = {
        where: {
          franchiseId,
        },
        include: [
          {
            relation: 'user',
            scope: {
              fields: {
                emailConfiguration: false,
                roles: false,
                firstName: true,
                lastName: true,
                id: true,
              },
            },
          },
          {
            relation: 'client',
            scope: {
              fields: {
                firstName: true,
                lastName: true,
              },
            },
          },
        ],
        fields: {
          id: true,
          user: true,
          assignedTo: true,
          clientId: true,
          createdAt: true,
          dateSaleNote: true,
          folio: true,
          prefolio: true,
          salesInformation: true,
          operatorsList: true,
          operatorsPaymentSale: true,
          delete: true,
          balance: true,
        },
        order: ['createdAt DESC'],
        limit: this.state.pageSize,
        skip: (page - 1) * this.state.pageSize,
      };

      const franchise = await feathers
        .service('franchises')
        .get(franchiseId, { query: { $select: ['hideOrders'] } });

      if (franchise && franchise.hideOrders) {
        query.where.prefix = 'F';
      }

      const totalSales = await this.props.count(query.where);

      if (this.props && this.props.location && this.props.location.search) {
        let url = this.props.location.search;

        const queryString = url.split('?')[1];

        const params = new URLSearchParams(queryString);

        const nameSearch = params.get('nameSearch');
        const startDate = params.get('startDate');
        const endDate = params.get('endDate');

        let paramsQuery = {
          nameSearch,
          startDate,
          endDate,
          franchiseId,
        };

        await this.props.findByNameDates(paramsQuery);
      } else {
        this.props.find(query);
      }

      this.setState({
        page,
        totalSales: totalSales || 0,
        loadingSales: false,
      });
    } catch (error) {
      console.error('Error al cargar ventas:', error);
      this.setState({
        loadingSales: false,
      });
    }
  }

  handleSearch = (searchTerm) => {
    if (!searchTerm || searchTerm.trim() === '') {
      this.setState({ searchData: null });
      return;
    }

    const words = searchTerm.trim().toLowerCase().split(/\s+/).filter(Boolean);
    const index = this.state.searchIndex || [];

    const filtered = index.filter((sale) => {
      const folio = (sale.folio || '').toLowerCase();
      const prefolio = (sale.prefolio || '').toLowerCase();

      const salesInfo = sale.salesInformation || {};
      const dest = (salesInfo.destination || '').toLowerCase();
      const interest = (salesInfo.interest || '').toLowerCase();

      // EXTRAER CLIENTE (Revisar tanto sale.clientId como sale.client)
      let clientName = '';
      if (sale.clientId && sale.clientId.firstName) {
        clientName = `${sale.clientId.firstName} ${sale.clientId.lastName || ''}`.toLowerCase();
      } else if (sale.client && sale.client.firstName) {
        clientName = `${sale.client.firstName} ${sale.client.lastName || ''}`.toLowerCase();
      }
      // EXTRAER AGENTE (Revisar tanto en salesInformation como directo en sale)
      let assignedName = '';
      const assigned = salesInfo.assignedTo || sale.assignedTo;
      if (assigned && assigned.firstName) {
        assignedName = `${assigned.firstName} ${assigned.lastName || ''}`.toLowerCase();
      }
      const operators = (sale.operatorsList || []).map((op) => (op.name || '').toLowerCase()).join(' ');

      // Unir todo el texto buscable
      const searchable = `${folio} ${prefolio} ${dest} ${interest} ${clientName} ${assignedName} ${operators}`;

      // Retornar true solo si TODAS las palabras escritas coinciden en algún lugar del string
      return words.every((word) => searchable.includes(word));
    });

    this.setState({ searchData: filtered });
  };


  editRecord = (id) => {
    //this.props.history.push('/admin/sales/' + id);
    window.open('#/admin/sales/' + id, '_blank');
  };

  search(event) {
    let search = event.target.value;
    this.props.searchTable(search);
  }

  onChangeDate = (path, value) => {
    var newDates;
    if (value) {
      newDates = immutable.set(this.state.dates, path, value);
      this.setState({
        dates: newDates,
        selectedDate: true,
      });
    } else {
      newDates = immutable.set(this.state.dates, path, value);
      this.setState({
        dates: newDates,
        selectedDate: false,
      });
    }
  };
  getClientId = (value) => {
    this.setState({
      clientId: value,
    });
  };
  getAgentId = (value) => {
    this.setState({
      assignedTo: value,
    });
  };


  handlePageSizeChange = (e) => {
    this.setState({ pageSize: Number(e.target.value) }, () => {
      this.loadSales(1);
    });
  };

  handlePageChange = (newPage) => {
    this.loadSales(newPage);
  };

  render() {
    const { history, Sales } = this.props;

    const context = {
      componentParent: {
        editRecord: (props) => this.editRecord(props),
      },
    };
    const {
      selectedDate,
      dates,
      franchiseId,
      clientId,
      modalType,
      assignedTo,
      reportSales,
      loadingSales,
      totalSales,
      page,
      pageSize,
    } = this.state;

    const receiptsFeathersURL = `${process.env.REACT_APP_URL_FEATHERS}/receipts-report/?startDate=${dates.startDate}&endDate=${dates.endDate}&franchiseId=${franchiseId}`;
    const salesFeathersURL = `${process.env.REACT_APP_URL_FEATHERS}/sales-excel-report/?startDate=${dates.startDate}&endDate=${dates.endDate}&franchiseId=${franchiseId}`;
    const clientFeathersURL = `${process.env.REACT_APP_URL_FEATHERS}/client-report/?startDate=${dates.startDate}&endDate=${dates.endDate}&franchiseId=${franchiseId}&clientId=${clientId}`;
    const agentFeathersURL = `${process.env.REACT_APP_URL_FEATHERS}/agents-report/?startDate=${dates.startDate}&endDate=${dates.endDate}&franchiseId=${franchiseId}&assignedTo=${assignedTo}`;

    const totalPages = Math.ceil(totalSales / pageSize) || 1;
    const fromRecord = totalSales > 0 ? (page - 1) * pageSize + 1 : 0;
    const toRecord = Math.min(page * pageSize, totalSales);

    return (
      <div className="main-content">
        <Modal
          open={this.state.showModal}
          onClose={() => {
            this.setState({ showModal: false });
          }}
          styles={{
            modal: { width: '580px' },
            overlay: { alignItems: 'flex-start' },
          }}
          closeOnOverlayClick={false}
        >
          <Grid fluid>
            <Col md={12}>
              <Row style={{ marginTop: '32px' }}>
                <div className="pull-left">
                  <div
                    style={{
                      fontSize: '24px',
                      marginBottom: '16px',
                      textAlign: 'center',
                    }}
                  >
                    {modalType === 'Recibos'
                      ? 'Reporte de Recibos'
                      : modalType === 'Ventas'
                        ? 'Reporte de Ventas'
                        : modalType === 'Cliente'
                          ? 'Reporte de Cliente'
                          : modalType === 'Agente' && auth.can('sales')
                            ? 'Reporte General de Agente'
                            : modalType === 'Agente'
                              ? 'Reporte de Agente'
                              : 'Reporte'}
                    <div className="clearfix" />
                  </div>
                  <label style={{ fontWeight: '250' }}>Desde :</label>
                  <input
                    style={{ color: '#000000', marginBottom: '16px' }}
                    type="date"
                    className="form-control"
                    value={dates.startDate}
                    onChange={(event) =>
                      this.onChangeDate('startDate', event.target.value)
                    }
                  />

                  <label style={{ fontWeight: '250' }}>Hasta :</label>
                  <input
                    style={{ color: '#000000', marginBottom: '48px' }}
                    type="date"
                    className="form-control"
                    value={dates.endDate}
                    onChange={(event) =>
                      this.onChangeDate('endDate', event.target.value)
                    }
                  />
                  {modalType === 'Cliente' && (
                    <div>
                      <Row style={{ marginTop: '32px' }}>
                        <Col md={12} style={{ marginBottom: '16px' }}>
                          <WidgetSearchName
                            schema={{
                              creatable: false,
                              title: 'Nombre, teléfono o correo del cliente',
                            }}
                            value={clientId}
                            required={false}
                            type={'clients'}
                            onChange={(value) => {
                              return this.getClientId(value);
                            }}
                          />
                        </Col>
                      </Row>
                    </div>
                  )}

                  {modalType === 'Agente' && !auth.can('sales') && (
                    <div>
                      <Row style={{ marginTop: '32px' }}>
                        <Col md={12} style={{ marginBottom: '16px' }}>
                          <WidgetSearchName
                            schema={{
                              creatable: false,
                              title: 'Nombre del agente',
                            }}
                            value={assignedTo}
                            required={false}
                            type={'users'}
                            onChange={(value) => {
                              return this.getAgentId(value);
                            }}
                          />
                        </Col>
                      </Row>
                    </div>
                  )}
                  <Button
                    bsStyle="primary"
                    style={{ marginBottom: '32px', marginLeft: '370px' }}
                    disabled={!selectedDate}
                    wd
                    href={
                      modalType === 'Recibos'
                        ? receiptsFeathersURL
                        : modalType === 'Ventas'
                          ? salesFeathersURL
                          : modalType === 'Cliente'
                            ? clientFeathersURL
                            : modalType === 'Agente'
                              ? agentFeathersURL
                              : null
                    }
                  >
                    Descargar Reporte
                  </Button>
                </div>
              </Row>
            </Col>
          </Grid>
        </Modal>
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title={
                  <div>
                    {'Lista de Órdenes de Venta'}{' '}
                    <div className="pull-right header-table">
                      <Navbar.Form
                        pullLeft
                        className="navbar-search-form"
                        media={{ minWidth: '400px' }}
                      >
                        <label style={{ fontSize: '16px', fontWeight: '250' }}>
                          Desde :
                        </label>
                        <input
                          id="date"
                          style={{ color: '#000000', fontSize: '15px' }}
                          type="date"
                          className="form-control"
                          //value={dates.startDate}
                          onChange={(event) =>
                            this.props.searchTableByDate(
                              'startDate',
                              event.target.value,
                              franchiseId
                            )
                          }
                        />
                        <label style={{ fontSize: '16px', fontWeight: '250' }}>
                          Hasta :
                        </label>
                        <input
                          id="date"
                          style={{ color: '#000000', fontSize: '15px' }}
                          type="date"
                          className="form-control"
                          onChange={(event) =>
                            this.props.searchTableByDate(
                              'endDate',
                              event.target.value,
                              franchiseId
                            )
                          }
                        />
                      </Navbar.Form>

                      <Navbar.Form
                        pullLeft
                        className="navbar-search-form"
                        style={{ minWidth: 300 }}
                      >
                        <FormGroup>
                          <InputGroup>
                            <InputGroup.Addon>
                              <i className="fa fa-search" />
                            </InputGroup.Addon>

                            <SearchBox
                              onSearch={(val) => this.props.searchTable(val)}
                            />

                          </InputGroup>
                        </FormGroup>
                      </Navbar.Form>
                      <Button
                        bsStyle="primary"
                        wd
                        onClick={() => history.push('/admin/sales/create')}
                      >
                        Agregar Orden de Venta
                      </Button>
                    </div>
                    {auth.can('support') ||
                      auth.can('admin') ||
                      auth.can('matriz') ? (
                      <div style={{ marginTop: '35px' }}>
                        <Button
                          bsStyle="primary"
                          wd
                          onClick={() =>
                            this.setState({
                              showModal: true,
                              modalType: 'Recibos',
                            })
                          }
                        >
                          Reporte de Recibos
                        </Button>
                        <Button
                          style={{ marginLeft: '24px' }}
                          bsStyle="primary"
                          wd
                          onClick={() =>
                            this.setState({
                              showModal: true,
                              modalType: 'Ventas',
                            })
                          }
                        >
                          Reporte de Ventas
                        </Button>
                        <Button
                          style={{ marginLeft: '24px' }}
                          bsStyle="primary"
                          wd
                          onClick={() =>
                            this.setState({
                              showModal: true,
                              modalType: 'Cliente',
                            })
                          }
                        >
                          Reporte de Cliente
                        </Button>
                        <Button
                          style={{ marginLeft: '24px' }}
                          bsStyle="primary"
                          wd
                          onClick={() =>
                            this.setState({
                              showModal: true,
                              modalType: 'Agente',
                            })
                          }
                        >
                          Reporte de Agente
                        </Button>
                      </div>
                    ) : null}
                    {auth.can('sales') ? (
                      <div style={{ marginTop: '35px' }}>
                        <Button
                          style={{ marginLeft: '24px' }}
                          bsStyle="primary"
                          wd
                          onClick={() =>
                            this.setState({
                              showModal: true,
                              modalType: 'Agente',
                              assignedTo: auth.getCurrentUser().id,
                            })
                          }
                        >
                          Reporte General de Agente
                        </Button>
                      </div>
                    ) : null}
                    <div className="clearfix" />
                  </div>
                }
                ctFullWidth
                content={
                  <div>
                    <div
                      id="myGrid"
                      style={{
                        height: '650px',
                        width: '100%',
                      }}
                      className="ag-theme-alpine"
                    >
                      <AgGridReact
                        rowData={Sales.searchData ? Sales.searchData : Sales.data}
                        //rowData={Sales.data}
                        //rowData={Sales.searchData ? Sales.searchData : Sales.data}
                        //quickFilterText={this.state.quickFilterText}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        frameworkComponents={frameworkComponents}
                        context={context}
                        suppressRowTransform={true}
                        localeText={localeText}
                        filterable={true}
                        sortable={true}
                        filter={true}
                        enableFilter={true}
                      />
                    </div>


                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: '12px',
                        padding: '12px 20px',
                        backgroundColor: '#fafbfc',
                        borderTop: '1px solid #e9ecef',
                        borderBottomLeftRadius: '6px',
                        borderBottomRightRadius: '6px',
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <span style={{ fontSize: '13px', color: '#6c757d' }}>Mostrar:</span>
                          <select
                            className="form-control"
                            style={{
                              height: '32px',
                              padding: '2px 8px',
                              fontSize: '13px',
                              width: '75px',
                              display: 'inline-block',
                              cursor: 'pointer',
                            }}
                            value={pageSize}
                            onChange={this.handlePageSizeChange}
                            disabled={loadingSales}
                          >
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </select>
                        </div>

                        <span style={{ fontSize: '13px', color: '#6c757d' }}>
                          Mostrando <strong>{fromRecord}</strong> – <strong>{toRecord}</strong> de{' '}
                          <strong style={{ color: '#2c3e50' }}>{totalSales}</strong> ventas
                        </span>
                      </div>

                      {/* Lado derecho: Botones de navegación de página */}
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <Button
                          bsSize="sm"
                          style={{ padding: '5px 10px' }}
                          disabled={page <= 1 || loadingSales}
                          onClick={() => this.loadSales(1)}
                          title="Primera página"
                        >
                          <i className="fa fa-angle-double-left" />
                        </Button>

                        <Button
                          bsSize="sm"
                          style={{ padding: '5px 12px' }}
                          disabled={page <= 1 || loadingSales}
                          onClick={() => this.loadSales(page - 1)}
                        >
                          <i className="fa fa-angle-left" /> Anterior
                        </Button>

                        <div
                          style={{
                            padding: '4px 12px',
                            fontSize: '13px',
                            backgroundColor: '#fff',
                            border: '1px solid #dcdcdc',
                            borderRadius: '4px',
                            margin: '0 4px',
                            color: '#333',
                          }}
                        >
                          Página <strong>{page}</strong> de <strong>{totalPages}</strong>
                          {loadingSales && (
                            <i
                              className="fa fa-spinner fa-spin"
                              style={{ marginLeft: '8px', color: '#457ef7' }}
                            />
                          )}
                        </div>

                        <Button
                          bsSize="sm"
                          style={{ padding: '5px 12px' }}
                          disabled={page >= totalPages || loadingSales}
                          onClick={() => this.loadSales(page + 1)}
                        >
                          Siguiente <i className="fa fa-angle-right" />
                        </Button>

                        <Button
                          bsSize="sm"
                          style={{ padding: '5px 10px' }}
                          disabled={page >= totalPages || loadingSales}
                          onClick={() => this.loadSales(totalPages)}
                          title="Última página"
                        >
                          <i className="fa fa-angle-double-right" />
                        </Button>
                      </div>
                    </div>

                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Sales: state.Sales,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(SalesActions, dispatch);
};

const SalesConnect = connect(mapStateToProps, mapDispatchToProps)(SalesIndex);

export default SalesConnect;



// WEBPACK FOOTER //
// ./src/views/Sales/SalesIndex.jsx